<template>
  <v-card outlined>
    <v-data-table
      :headers="headers"
      :items="convertEmployees"
      :items-per-page="1000"
      class="call-center-employee-table"
      v-if="convertEmployees.length"
      hide-default-footer
    >
      <template v-slot:item.totalCall="{ item }">
        {{ formatPrice(item.totalCall) }}
      </template>

      <template v-slot:item.totalDuration="{ item }">
        {{ (+item.totalDuration / 60).toFixed(2) }}
      </template>

      <template v-slot:item.numberOfOrders="{ item }">
        {{ formatPrice(item.numberOfOrders) }}
      </template>

      <template v-slot:item.totalPrice="{ item }">
        {{ formatPrice(item.totalPrice) }}
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
  export default {
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      convertEmployees: Array,
      default: () => []
    },
    data () {
      return {
        convertEmployee: {},
        headers: [
          { text: 'Nhân viên', align: 'center', value: 'user.fullName' },
          { text: 'Tổng số cuộc gọi thành công', align: 'center', value: 'totalSuccess' },
          { text: 'Thời gian gọi ( phút )', align: 'center', value: 'totalDuration' },
          { text: 'Số đơn', align: 'center', value: 'countInitOrders' },
          { text: 'Doanh thu', align: 'center', value: 'initTurnOver' },
        ],
      }
    }
  }
</script>

<style lang="scss">
  .call-center-employee-table {
    tr th:not(:last-child), tr td:not(:last-child) {
      border-right: thin solid rgba(0, 0, 0, 0.12);
    }
    tr th {
      text-transform: uppercase;
      font-weight: 500;
      background-color: #9e9e9e;
      span {
        color: #ffffff;
      }
      i {
        color: #ffffff!important;
      }
    }
  }
</style>
